<template>
  <div>
    <div v-if="showGuideType == id" class="newGuide" :style="{left:guideLeft,top:guideTop}">
      <div class="circle" v-html="htmlContent"></div>
      <div class="line"></div>
      <div class="info">
        <p class="title">{{guideType}} {{guideStep}} / 2</p>
        <div class="box">
          <p class="close" @click="closeGuide"><span>×</span></p>
          <p class="join">{{guideText}}</p>
          <p class="btn" @click="nextGuide">{{$t('guide_task')}}</p>
        </div>
      </div>
    </div>
    <div v-if="showGuideType == id" class="ivu-modal-mask" style="z-index: 1003;"></div>
  </div>

</template>

<script>
import {
  abkLink
} from 'assets/scripts/common';

export default {
  data () {
    return {
      searchData: '',
      guideLeft: 0,
      guideTop: 0,
      showGuideType: ''
    };
  },
  props: ['guideStep', 'guideText', 'btnText', 'id', 'htmlContent', 'left', 'top', 'link', 'guideType'],
  watch: {
    $route (val) {
      this.closeGuide();
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      let top = this.top ? this.top : 0;
      let left = this.left ? this.left : 0;
      var guideRef = (this.$parent.$refs[this.id + 'Box'] && this.$parent.$refs[this.id + 'Box'][0]) || (this.$parent.$refs[this.id + 'Box']);
      this.guideTop = this.getTop(guideRef) + top + 'px';
      this.guideLeft = this.getLeft(guideRef) + left + 'px';
    })
  },
  methods: {
    // 获取元素的纵坐标
    getTop: function (e) {
      if (!e) return;
      var offset = e.offsetTop;
      if (e.offsetParent != null) offset += this.getTop(e.offsetParent);
      return offset;
    },
    // 获取元素的横坐标
    getLeft: function (e) {
      if (!e) return;
      var offset = e.offsetLeft;
      if (e.offsetParent != null) offset += this.getLeft(e.offsetParent);
      return offset;
    },
    nextGuide: function () {
      if (this.link) {
        window.open(abkLink() + this.link + '?guide=true');
      }
      this.showGuideType = '';
    },
    closeGuide: function () {
      this.showGuideType = '';
    },
    showGuide: function () {
      this.showGuideType = this.id;
      document.body.scrollTop = parseInt(this.guideTop) - 200;
      document.documentElement.scrollTop = parseInt(this.guideTop) - 200;

      // window.scrollTo({
      //   'top': parseInt(this.guideTop) - 200,
      //   behavior: 'smooth'
      // })
    }
  }

};
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .newGuide {
    position: absolute;
    width: 450px;
    height: 145px;
    z-index: 1004;
    top: 0;
    left: 0;

    .circle {
      width: 140px;
      height: 140px;
      border: 7px solid #22A578;
      background: #fff;
      border-radius: 70px;
      float: left;

      .btn {
        display: inline-block;
        width: 90px;
        height: 34px;
        line-height: 34px;
        background: #ffffff;
        text-align: center;
        border-radius: 2px;
        padding: 0 24px;
        font-weight: bold;
        border: 1px solid #14CB6B;
        color: #14CB6B;
        cursor: pointer;
        margin-left: 18px;
        margin-top: 46px;
      }
    }

    .line {
      float: left;
      width: 112px;
      height: 135px;
      background: url(../../assets/images/default/line.png) no-repeat center 73px;
    }

    .info {
      float: left;
      width: 175px;
      height: 135px;

      .title {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 9px;
      }

      .box {
        width: 196px;
        height: 109px;
        background: linear-gradient(0deg, rgba(41, 229, 156, 1), rgba(16, 193, 189, 1));
        border-radius: 0px 29px 29px 29px;
        text-align: center;

        .close {
          text-align: right;

          margin-right: 30px;
          color: #fff;

          span {
            font-size: 20px;
            cursor: pointer;
          }
        }

        .join {
          font-size: 18px;
          font-weight: 400;
          color: #fff;
          margin-bottom: 10px;
          margin-top: -5px;
        }

        .btn {
          border: 1px solid #fff;
          border-radius: 4px;
          font-size: 14px;
          font-weight: 400;
          color: #fff;
          display: inline-block;
          padding: 6px 20px;
          cursor: pointer;
        }
      }
    }
  }
</style>
